import { render, staticRenderFns } from "./CollegeSignIn.vue?vue&type=template&id=60bc87a2"
import script from "./CollegeSignIn.vue?vue&type=script&lang=js"
export * from "./CollegeSignIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports